export const gameInviteNotification = {
    type: 'game-invite',
    name: 'Game Invite',
    description: 'Sent when someone invites you to play a game on Rout.',
    emailRequired: true,
    defaultEnabled: true,
    text(data, context) {
        return `${data.inviterName} invited you to play a game.${context === 'push' ? ' Tap to join!' : ''}`;
    },
    title() {
        return `New game invite!`;
    },
    link(data) {
        return `/session/${data.gameSessionId}`;
    },
};
//# sourceMappingURL=gameInvite.js.map